import * as i0 from "@angular/core";
export class PageNotFoundHomeStore {
}
PageNotFoundHomeStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PageNotFoundHomeStore_Factory() { return new PageNotFoundHomeStore(); }, token: PageNotFoundHomeStore, providedIn: "root" });
export var PageNotFoundHomeStoreKeys;
(function (PageNotFoundHomeStoreKeys) {
})(PageNotFoundHomeStoreKeys || (PageNotFoundHomeStoreKeys = {}));
